<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="!isLoading"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '100%', maxWidth: '480px' }"
  styleClass="password-reset-dialog"
  (onHide)="onClose()"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">
      {{ 'USER.RESET_PASSWORD.TITLE' | translate }}
    </span>
  </ng-template>

  <ng-template pTemplate="content">
    <!-- Estado: success -->
    <div *ngIf="isSuccess" class="reset-success">
      <i class="pi pi-check-circle reset-success__icon"></i>
      <p class="reset-success__message">
        {{ 'USER.RESET_PASSWORD.SUCCESS_MESSAGE' | translate }}
      </p>
    </div>

    <!-- Estado: default / loading / error -->
    <div *ngIf="!isSuccess" class="reset-form">
      <p class="reset-form__description">
        {{ 'USER.RESET_PASSWORD.DESCRIPTION' | translate }}
      </p>

      <div [formGroup]="form" class="reset-form__field">
        <label for="reset-email" class="font-medium">
          {{ 'USER.RESET_PASSWORD.EMAIL_LABEL' | translate }}
        </label>
        <input
          id="reset-email"
          pInputText
          type="email"
          formControlName="email"
          [placeholder]="'USER.RESET_PASSWORD.EMAIL_PLACEHOLDER' | translate"
          [class.ng-invalid]="emailControl.invalid && emailControl.touched"
          [class.ng-dirty]="emailControl.dirty"
        />
        <small
          *ngIf="emailControl.invalid && emailControl.touched"
          class="p-error"
        >
          <span *ngIf="emailControl.errors?.['required']">
            {{ 'USER.RESET_PASSWORD.EMAIL_REQUIRED' | translate }}
          </span>
          <span *ngIf="emailControl.errors?.['email']">
            {{ 'USER.RESET_PASSWORD.EMAIL_INVALID' | translate }}
          </span>
        </small>
      </div>

      <p-messages
        *ngIf="state === 'error'"
        [value]="[{ severity: 'error', detail: ('USER.RESET_PASSWORD.ERROR_DETAIL' | translate) }]"
        [closable]="false"
      ></p-messages>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div *ngIf="!isSuccess" class="reset-footer-actions">
      <p-button
        [label]="'USER.RESET_PASSWORD.CANCEL' | translate"
        [text]="true"
        severity="secondary"
        [disabled]="isLoading"
        (onClick)="onClose()"
      ></p-button>

      <p-button
        [label]="'USER.RESET_PASSWORD.SUBMIT' | translate"
        [raised]="true"
        [disabled]="form.invalid || isLoading"
        (onClick)="onSubmit()"
      >
        <ng-template pTemplate="icon">
          <p-progressSpinner
            *ngIf="isLoading"
            styleClass="reset-spinner"
            strokeWidth="4"
          ></p-progressSpinner>
        </ng-template>
      </p-button>
    </div>

    <div *ngIf="isSuccess" class="reset-footer-close">
      <p-button
        [label]="'USER.RESET_PASSWORD.CLOSE' | translate"
        [raised]="true"
        (onClick)="onClose()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
